<template>
    <div class="status">

        <div class="wrap">
            <div class="wrap__tree">
                <div class="nav-tree">
                  <!-- select -->
                  <el-select v-model="usersId" clearable size="mini" :placeholder="$t('settings_documentManagment_status_userSelect')" style="margin-right:20px;">
                    <el-option v-for="item in usersList"
                      :key="item.user.id"
                      :label="item.user.fullName"
                      :value="item.user.id">
                    </el-option>
                  </el-select>
                  <!-- checkbox -->
                  <el-checkbox :disabled="checkedReject || checkedInfo || checkedReview || checkedPending" v-model="checkedAccept">{{$t('users_tab_document_accept')}}</el-checkbox>
                  <el-checkbox :disabled="checkedAccept || checkedInfo || checkedReview || checkedPending" v-model="checkedReject">{{$t('users_tab_document_reject')}}</el-checkbox>
                  <el-checkbox :disabled="checkedAccept || checkedReject || checkedReview || checkedPending" v-model="checkedInfo">{{$t('users_tab_document_info')}}</el-checkbox>
                  <el-checkbox :disabled="checkedAccept || checkedReject || checkedInfo || checkedPending" v-model="checkedReview">{{$t('users_tab_document_review')}}</el-checkbox>
                  <el-checkbox :disabled="checkedAccept || checkedReject || checkedInfo || checkedReview" v-model="checkedPending">{{$t('users_tab_document_pending')}}</el-checkbox>
                </div>
                <el-table
                  max-height="650"
                  :data="tableData"
                  style="width: 100%"
                  :empty-text="$t('general_noData')"
                  @row-click="rowClick"
                  :row-class-name="tableRowClassName">
                  <el-table-column
                    label="ID"
                    type="index"
                    width="50">
                  </el-table-column>
                  <el-table-column
                    prop="userName"
                    width="220"
                    :label="$t('settings_documentManagment_status_user')">
                  </el-table-column>
                  <!-- <el-table-column
                     prop="projectType"
                     :label="$t('settings_documentManagment_status_type')">
                  </el-table-column>
                  <el-table-column
                    prop="projectName"
                    :label="$t('settings_documentManagment_status_name')">
                  </el-table-column>
                  <el-table-column
                    prop="taskName"
                    :label="$t('settings_documentManagment_status_taskName')">
                  </el-table-column> -->
                  <el-table-column
                    :label="$t('settings_documentManagment_status_document')"
                    width="120"
                    sortable>
                    <template slot-scope="scope">
                      <el-popover trigger="hover" placement="top">
                        <p>Type: {{ scope.row.projectType }}</p>
                        <p>Name: {{ scope.row.projectName }}</p>
                        <p>Task Name: {{ scope.row.taskName }}</p>
                        <div slot="reference" class="name-wrapper">
                          <span size="medium" v-if="scope.row.docType === 'sop'">SOP</span>
                          <span size="medium" v-else-if="scope.row.docType === 'healthsafety'">Health & Safety</span>
                          <span size="medium" v-else>{{ capitalizeFirstLetter(scope.row.docType) }}</span>
                        </div>
                      </el-popover>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="docNumber"
                    :label="$t('settings_documentManagment_status_no')"
                    width="150">
                  </el-table-column>
                  <el-table-column
                    prop="docName"
                    :label="$t('settings_documentManagment_status_documentName')">
                  </el-table-column>
                  <el-table-column
                    prop="lastUpdateDate"
                    :label="$t('settings_documentManagment_status_updateDate')"
                    width="150">
                  </el-table-column>
                  <el-table-column
                    prop="createDate"
                    :label="$t('settings_documentManagment_status_createDate')"
                    width="150">
                  </el-table-column>
                  <el-table-column
                    :label="$t('settings_documentManagment_status_status')"
                    width="120">
                    <!-- @click="rejectMsg(scope.row.rejectMessage)" -->
                    <template slot-scope="scope">
                      <!-- && !scope.row.isAccepted && !scope.row.isRejected -->
                      <!-- <el-tag v-if="scope.row.isAccepted" type="success">Accepted</el-tag>
                      <el-tag v-if="scope.row.isRejected" @click="rejectMsg(scope.row.rejectMessage)" type="danger" style="cursor: pointer;">Rejected</el-tag>
                      <el-tag v-if="scope.row.level != 0 && !scope.row.isAccepted && !scope.row.isRejected" type="info">Review</el-tag>
                      <el-tag v-if="scope.row.level == 0 && !scope.row.isAccepted && !scope.row.isRejected">Info</el-tag> -->
                      <el-tag v-if="scope.row.isAccepted" type="success">{{$t('settings_documentManagment_status_accepted')}}</el-tag>
                      <el-tag v-if="scope.row.isRejected" type="danger" style="cursor: pointer;">{{$t('settings_documentManagment_status_rejected')}}</el-tag>
                      <el-tag v-if="scope.row.level == 0 && !scope.row.isAccepted && !scope.row.isRejected">{{$t('settings_documentManagment_status_info')}}</el-tag>
                      <el-tag v-if="scope.row.level != 0 && !scope.row.isAccepted && !scope.row.isRejected && !scope.row.date" type="info">{{$t('settings_documentManagment_status_pending')}}</el-tag>
                      <el-tag v-if="scope.row.level != 0 && !scope.row.isAccepted && !scope.row.isRejected && scope.row.date" type="info">{{$t('settings_documentManagment_status_review')}}</el-tag>
                    </template>
                  </el-table-column>
                </el-table>
            </div>
        </div>
        <document-info-modal ref="documentInfoModal" :rejectMessage="rejectMessage"/>
    </div>
</template>

<script>
  // import Header from '@/components/Header.vue'
  // import Menu from '@/components/Menu.vue'

  import DocumentInfoModal from "./documentModal/index";
  let moment = require('moment')
  import axios from 'axios'
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
  import { VueEditor } from 'vue2-editor'

  export default {
    components: {
      DocumentInfoModal,
      // Header,
      // Menu,
      SweetModal,

      VueEditor
    },
    data() {
      return {
        moment:moment,

        tableData: [],

        usersList: [],
        usersId: null,

        checkedAccept: false,
        checkedReject: false,
        checkedInfo: false,
        checkedReview: false,
        checkedPending: false,

        // TODO: whatch
        checkedStatus: 0,
        rejectMessage: null,
      }
    },
    watch: {
      checkedAccept(val) {
        if (val && !this.checkedReject) {
          this.checkedStatus = 1
        } else {
          this.checkedStatus = 0
        }

        this.loadList()
      },
      checkedReject(val) {
        if (val && !this.checkedAccept) {
          this.checkedStatus = 2
        } else {
          this.checkedStatus = 0
        }

        this.loadList()
      },
      checkedInfo(val) {
        if (val && !this.checkedAccept && !this.checkedReject && !this.checkedReview && !this.checkedPending) {
          this.checkedStatus = 3
        } else {
          this.checkedStatus = 0
        }

        this.loadList()
      },
      checkedReview(val) {
        if (val && !this.checkedAccept && !this.checkedReject && !this.checkedInfo && !this.checkedPending) {
          this.checkedStatus = 4
        } else {
          this.checkedStatus = 0
        }

        this.loadList()
      },
      checkedPending(val) {
        if (val && !this.checkedAccept && !this.checkedReject && !this.checkedInfo && !this.checkedReview) {
          this.checkedStatus = 5
        } else {
          this.checkedStatus = 0
        }

        this.loadList()
      },
      usersId(val) {
        if (val == '') {
          this.usersId = null
        }

        this.loadList()
      },
    },
    created() {
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
          .post(`/api/v1/companyUsers/list?companyId=${this.$route.query.companyId}`)
          .then(response => {
              this.usersList = response.data.list
              loader.hide()
          })
          .catch(error => {
            loader.hide()
            console.log('An error occurred:', error);
          });
    },
    methods: {
      // * list
      loadList(){
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
            .post(`/api/v1/documentHistory/list?companyId=${this.$route.query.companyId}&userId=${this.usersId}&statusId=${this.checkedStatus}&companyUserRequest=false`)
            .then(response => {
                let list = response.data.list;
                for (let i = 0; i < list.length; i++) {
                  if (list[i].docType == 'riskassesment') {
                    list[i].docType = 'commercial'
                  }
                  if (list[i].docType == 'envirenmental') {
                    list[i].docType = 'general'
                  }
                  list[i].createDate = list[i].createDate ? moment(list[i].createDate * 1000).format("D MMM YY") : '';
                  list[i].lastUpdateDate = list[i].lastUpdateDate ? moment(list[i].lastUpdateDate * 1000).format("D MMM YY") : ''
                }

                list.sort(function (a, b) {
                  if (moment(a.lastUpdateDate, "D MMM YY").format('x') > moment(b.lastUpdateDate, "D MMM YY").format('x')) {
                    return -1;
                  }
                  if (moment(a.lastUpdateDate, "D MMM YY").format('x') < moment(b.lastUpdateDate, "D MMM YY").format('x')) {
                    return 1;
                  }
                  return 0;
                });
                // this.tableData = response.data.list
                this.tableData = list
                loader.hide()
            })
            .catch(error => {
              loader.hide()
              console.log('An error occurred:', error);
            });
      },
      rejectMsg(msg) {
        this.$alert(msg, 'Reject', {
          confirmButtonText: 'OK'
        });
      },
      // main
      showMenu() {
        this.open = true;
        console.log('---', this.open);
      },
      hideMenu() {
        this.open = false;
        console.log('---', this.open);
      },
      companyName(name) {
        this.companyNameSelect = name
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      },
      rowClick(row) {
        if (row.rejectMessage) {
          this.rejectMessage = row.rejectMessage
        } else {
          this.rejectMessage = null
        }
        // eslint-disable-next-line no-console
        this.$refs.documentInfoModal.openModal(row);
        console.log('---ROW', row);
      },
      tableRowClassName({row, rowIndex}) {
        return 'table-rows'
      },
      capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
      }
    },
  }
</script>

<style lang="scss" scoped>
    .status{
      min-width:810px;
    }
    .table-rows{
        cursor:pointer;
    }
</style>
